/**
 * Layout Component
 * Main layout wrapper with navigation and content area
 */

import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Navigation } from './Navigation';
import { UserRole } from '../auth';
import { canAccessAIChat } from '../auth/permissions';
import { AIChatPanel } from './ai-chat/AIChatPanel';
import { FEATURE_FLAGS } from '../config/featureFlags';

interface LayoutProps {
  userName?: string;
  userRole?: UserRole;
}

export const Layout: React.FC<LayoutProps> = ({ userName = 'Guest', userRole }) => {
  const [isAIChatOpen, setIsAIChatOpen] = useState(false);

  const showAIChat = FEATURE_FLAGS.AI_CHAT_ENABLED && canAccessAIChat(userRole || null);

  return (
    <div className="min-h-screen bg-gray-100">
      <Navigation
        userName={userName}
        userRole={userRole}
        isAIChatOpen={isAIChatOpen}
        onToggleAIChat={showAIChat ? () => setIsAIChatOpen(!isAIChatOpen) : undefined}
      />
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-slate-800 text-slate-400 py-4 mt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center text-sm">
            <p>&copy; 2025 Dealership Profit Forecasting Tool</p>
            <p className="mt-2 sm:mt-0">Version 2.0</p>
          </div>
        </div>
      </footer>

      {/* AI Chat Panel - completely modular, renders independently */}
      {showAIChat && (
        <AIChatPanel isOpen={isAIChatOpen} onClose={() => setIsAIChatOpen(false)} />
      )}
    </div>
  );
};
